<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap no-footer">
    <div v-show="!!loader" class="loader-container text-center">
      <div class="icon">
        <div class="sk-wave">
          <div class="sk-rect sk-rect1"></div>
          <div class="sk-rect sk-rect2"></div>
          <div class="sk-rect sk-rect3"></div>
          <div class="sk-rect sk-rect4"></div>
          <div class="sk-rect sk-rect5"></div>
        </div>
      </div>
      <div class="title">{{ loader }}</div>
    </div>

    <template v-if="!loader">
      <slot></slot>
    </template>

    <div v-show="!loader" class="bottom">
      <div class="dataTables_info"role="status" aria-live="polite">
        {{ countStatus }}
      </div>
      <div class="dataTables_paginate paging_simple_numbers" v-show="pages > 1">
        <ul class="pagination">
          <li v-show="notFirst" class="paginate_button previous" v-on:click="refresh(offset - 1)">
            <a href="#" tabindex="0">{{ $t('Action.prev') }}</a>
          </li>
          <li v-for="page in pages" :class="['paginate_button', {'active': isCurrent(page - 1)}]" v-on:click="refresh(page - 1)">
            <a href="#" tabindex="0">{{ page }}</a>
          </li>
          <li v-show="notLast" class="paginate_button next" v-on:click="refresh(offset + 1)">
            <a href="#" tabindex="0">{{ $t('Action.next') }}</a>
          </li>
        </ul>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    loader: {
      type: String,
    },
    offset: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 0
    },
    count: {
      type: Number,
      default: 0
    },
    pages: {
      type: Number,
      default: 0
    }
  },
  watch: {
    loader() {}
  },
  computed: {
    notFirst() {
      return this.offset > 0;
    },
    notLast() {
      return this.offset < this.pages - 1;
    },
    countStatus() {
      if (this.count == 0)
        return this.$t('Common.noEntries');

      var from = (this.offset) * this.limit + 1;
      var to   = (this.offset + 1) * this.limit;
      to = to < this.count ? to : this.count;

      if (this.count <= this.limit)
        return this.$t('Common.showXtoYentries', {x: from, y: to});

      return this.$t('Common.showXtoYentries', {x: from, y: to, z: this.count});
    }
  },
  methods: {
    refresh(offset) {
      this.$emit('refresh', offset);
    },
    isCurrent(page) {
      return this.offset == page;
    }
  }
}
</script>
<style scoped>
  .loader-container {
    min-height: 150px;
    display: block;
    opacity: .6;
  }
</style>
